<div class="bg-[#2D2D2D] text-gray-200 font-sans antialiased rounded-lg shadow-2xl flex flex-col overflow-hidden border border-[#404040]"
        [ngClass]="device().type === 'CCTV' ? 'w-[32rem]' : 'w-[20rem] max-h-[300px]'">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 pt-4 pb-2">
                <div class="flex items-center gap-2">
                        <i class="ci text-2xl text-white {{ iconClass() }}"></i>
                        <span class="text-white text-lg tracking-wide">{{ displayName() }}</span>
                </div>
                <div class="flex items-center gap-3 text-gray-300 text-lg">
                        <i class="pi pi-external-link cursor-pointer hover:text-white transition-colors"
                                (click)="openDetail($event)"></i>
                        <i class="pi pi-times cursor-pointer hover:text-white transition-colors"
                                (click)="closePopup($event)"></i>
                </div>
        </div>

        <div class="px-4 pb-4 flex flex-col gap-2 text-[15px] overflow-y-auto flex-1 min-h-0 custom-scrollbar">
                @switch (device().type) {
                @case ('DOOR') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_Online_Status']?.isAlarm}">{{
                                formatPower(device().data?.['01_Online_Status']?.value) }}</span></div>
                <div>門位狀態: <span>{{ formatDoorStatus(device().data?.['01_Door_Status']?.value) }}</span></div>
                <div>開門超時狀態(>1分鐘): <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['01_Door_Open_Too_Long']?.value === 1}">{{
                                formatDoorOpenTooLong(device().data?.['01_Door_Open_Too_Long']?.value) }}</span></div>
                }
                @case ('FAN') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': (device().data?.['01_ErrStatus']?.isAlarm || device().data?.['Online']?.isAlarm)}">{{
                                formatPower(device().data?.['01_ErrStatus']?.value ?? device().data?.['Online']?.value) }}</span></div>
                <div>電源狀態: <span>{{ device().data?.['01_Power']?.value === 1 ? '開機' : '關機' }}</span></div>
                <div>運轉模式: <span>{{ formatFanRunMode(device().data?.['01_RunMode']?.value) }}</span></div>
                <div>異常狀態: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['02_ErrorStatus']?.value !== 0 && device().data?.['02_ErrorStatus']?.value !== undefined && device().data?.['02_ErrorStatus']?.value !== null && device().data?.['02_ErrorStatus']?.value !== ''}">{{
                                formatFanErrorStatus(device().data?.['02_ErrorStatus']?.value) }}</span></div>
                }
                @case ('CCTV') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['Online']?.isAlarm}">{{
                                formatPower(device().data?.['Online']?.value) }}</span></div>
                @if (webrtcUrl()) {
                <div class="w-full mt-2">
                        <iframe [src]="webrtcUrl()" class="w-full aspect-video border-none rounded-lg bg-black"
                                allow="fullscreen"></iframe>
                </div>
                }
                }
                @case ('AC') {
                <div>錯誤狀態: <span
                                [ngClass]="{'text-red-500 font-bold': (device().data?.['ErrorStatus_' + device().acSubId]?.isAlarm || device().data?.['ErrorStatus_' + device().acSubId]?.value === 1)}">{{
                                formatErrorStatus(device().data?.['ErrorStatus_' + device().acSubId]?.value) }}</span>
                </div>
                <div>電源狀態: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['Power_' + device().acSubId]?.isAlarm}">{{
                                formatPower(device().data?.['Power_' + device().acSubId]?.value) }}</span></div>
                <div>運轉模式: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['Mode_' + device().acSubId]?.isAlarm}">{{
                                formatMode(device().data?.['Mode_' + device().acSubId]?.value) }}</span></div>
                <!-- <div>設定溫度: <span
                        [ngClass]="{'text-red-500 font-bold': device().data?.['SetTemp_' + device().acSubId]?.isAlarm}">{{
                        device().data?.['SetTemp_' + device().acSubId]?.value ?? '-' }} °C</span></div> -->
                <div>室內溫度: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['RoomTemp_' + device().acSubId]?.isAlarm}">{{
                                device().data?.['RoomTemp_' + device().acSubId]?.value ?? '-' }} °C</span></div>
                }
                @case ('AIR_QUALITY') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['08_ErrStatus']?.isAlarm}">{{
                                formatPower(device().data?.['08_ErrStatus']?.value) }}</span></div>
                <div>二氧化碳值: <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_CO2']?.isAlarm}">{{
                                device().data?.['01_CO2']?.value ?? '-' }} ppm</span></div>
                <div class="flex items-center gap-1">
                        <span>舒適指標:</span>
                        <span [ngClass]="comfortStatus().color">{{ comfortStatus().text }}</span>
                </div>
                <div class="flex items-center gap-1">
                        <span>空氣品質:</span>
                        <span [ngClass]="qualityStatus().color">{{ qualityStatus().text }}</span>
                </div>
                }
                @case ('LIGHT') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['Online']?.isAlarm}">{{
                                device().isOnline ?
                                '連線中' : '離線' }}</span></div>
                @for (point of lightPoints(); track point.id) {
                <div>{{ point.name }}: <span [ngClass]="{'text-red-500 font-bold': point.isAlarm}">{{
                                point.value === 1 ? '開燈' : point.value === 0 ? '關燈' : '-'
                                }}</span></div>
                }
                }

                @case ('POWER') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': (device().data?.['08_ErrStatus']?.isAlarm || device().data?.['ErrStatus']?.isAlarm)}">{{
                                formatPower(device().data?.['08_ErrStatus']?.value ?? device().data?.['ErrStatus']?.value) }}</span></div>
                <div>CH1功率總和: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['07_Ch1_Watt_Tot']?.isAlarm}">{{
                                device().data?.['07_Ch1_Watt_Tot']?.value ?? '-' }} kW</span></div>
                <div>CH2功率總和: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['07_Ch2_Watt_Tot']?.isAlarm}">{{
                                device().data?.['07_Ch2_Watt_Tot']?.value ?? '-' }} kW</span></div>
                @if (isThreePhaseMeter()) {
                <div>CH3功率總和: <span
                                [ngClass]="{'text-red-500 font-bold': device().data?.['07_Ch3_Watt_Tot']?.isAlarm}">{{
                                device().data?.['07_Ch3_Watt_Tot']?.value ?? '-' }} kW</span></div>
                }
                }
                @case ('PANEL') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_3']?.isAlarm}">{{
                                formatPower(device().data?.['01_3']?.value) }}</span></div>
                <div class="flex items-center gap-1">
                        <span>會議室狀態:</span>
                        <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_1']?.isAlarm}">
                                {{ formatRoomStatus(device().data?.['01_1']?.value) }}
                        </span>
                </div>
                }
                @case ('RB') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_4']?.isAlarm}">{{
                                formatPower(device().data?.['01_4']?.value) }}</span></div>
                <div>使用狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['01_2']?.isAlarm}">{{
                                formatBlindStatus(device().data?.['01_2']?.value) }}</span></div>
                }
                @case ('HOST') {
                <div>設備運轉狀態: <span [ngClass]="{'text-red-500 font-bold': device().data?.['Online']?.isAlarm}">{{
                                formatPower(device().data?.['Online']?.value) }}</span></div>
                }
                }
        </div>
</div>